export default {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  beforeMount(el, binding) {
    const defaultExcludedClasses = [
      'slick-arrow', // Strzałki Slick Slider
      'swiper-button-next', // Przycisk "Next" Swiper
      'swiper-button-prev', // Przycisk "Prev" Swiper
      'glide__arrow', // Strzałki Glide.js
      'splide__arrow', // Strzałki Splide.js
      'tns-controls', // Kontrolki Tiny-slider
      'flickity-prev-next-button', // Przycisk "Prev" i "Next" Flickity
      'owl-nav', // Strzałki Owl Carousel
      'owl-dot', // Punkty nawigacyjne Owl Carousel
      'slider-nav-left',
      'slider-nav-right'
    ];
    
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    el.clickOutsideEvent = function (event) {
      const additionalExcludedClasses = window._QONizer?.customSmartSearchConfig?.excludedClasses || [];
      const allExcludedClasses = [...defaultExcludedClasses, ...additionalExcludedClasses];
      
      if (!(el === event.target || el.contains(event.target))) {
        if (!allExcludedClasses.some(className => event.target.closest(`.${className}`))) {
          binding.value(event);
        }
      }
    };
    
    document.addEventListener('click', el.clickOutsideEvent);
  },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  unmounted(el) {
    document.removeEventListener('click', el.clickOutsideEvent);
  },
};
